import { MaalerAflaesning } from "../../model/maaler-aflaesning.model";
import { MaalerType } from "../../model/maaler-type.model";

export interface InstallationMaalerAflaesning {
    ejendomNr: number;
    installationNr: number;
    aktivNr: number;
    dato: Date;
    aflaesning: MaalerAflaesning;
}

export interface InstallationMaalerAflaesningMedMaalerType extends InstallationMaalerAflaesning {
    maalerType: MaalerType;
}
